export type SpecialPricingExpirationExcelTemplate = {
    CONTROLNUMBER: string | null,
    CUSTOMERNUMBER: string | null,
    AGREEMENTNUMBER: string | null,
    CUSTOMERNAME: string | null,
    CUSTOMERADDRESS: string | null,
    PRODUCTLINE: string | null,
    PRODUCTLINEDESCRIPTION: string | null,
    PRODUCTCATEGORY: string | null,
    PRODUCTCATEGORYDESCRIPTION: string | null,
    EMPLOYEERESPONSIBLENAME: string | null,
    CONTRACTNUMBER: string | null,
    CONTRACTNAME: string | null,
    ITEM: string | null,
    ITEMDESCRIPTION: string | null,
    MANUFACTURERSNUMBER: string | null,
    PRICETYPE: string | null,
    PRICE: string | null,
    PRICINGUOM: string | null,
    FLOATPERCENT: string | null,
    DELIVERYEFFECTIVEDATE: string | null,
    DELIVERYEXPIRATIONDATE: string | null,
    "EXTEND/DELETE/CANCEL/NEW": string | null,
    EXTENDDATE: string | null,
    COMMENTS: string | null,
    NEWPRICINGAMOUNT: string | null,
    NEWPRICEUOM: string | null,
    NEWCONTRACTNUMBER: string | null,
    NEWCONTRACTNAME: string | null,
    NEWSTARTDATE: string | null,
    NEWENDDATE: string | null,
    CONTACTEMAIL: string | null
}

export const SpecialPricingExpirationExcelTemplate_Default = {
    CONTROLNUMBER: "",
    CUSTOMERNUMBER: "",
    AGREEMENTNUMBER: "",
    CUSTOMERNAME: "",
    CUSTOMERADDRESS: "",
    PRODUCTLINE: "",
    PRODUCTLINEDESCRIPTION: "",
    PRODUCTCATEGORY: "",
    PRODUCTCATEGORYDESCRIPTION: "",
    EMPLOYEERESPONSIBLENAME: "",
    CONTRACTNUMBER: "",
    CONTRACTNAME: "",
    ITEM: "",
    ITEMDESCRIPTION: "",
    MANUFACTURERSNUMBER: "",
    PRICETYPE: "",
    PRICE: "0",
    PRICINGUOM: "",
    FLOATPERCENT: "0",
    DELIVERYEFFECTIVEDATE: "",
    DELIVERYEXPIRATIONDATE: "",
    "EXTEND/DELETE/CANCEL/NEW": null,
    EXTENDDATE: "",
    COMMENTS: "",
    NEWPRICINGAMOUNT: "0",
    NEWPRICEUOM: "0",
    NEWCONTRACTNUMBER: "",
    NEWCONTRACTNAME: "",
    NEWSTARTDATE: "",
    NEWENDDATE: "",
    CONTACTEMAIL: ""
} as SpecialPricingExpirationExcelTemplate;
